import { apiUrl } from '../../config.json';
import axios from 'axios'

const apiEndPoint = apiUrl;

export async function login(username, password) {
    let response = await axios.post(`${apiEndPoint}/auth/login`, { username, password })
    let { data: user, token } = response.data
    localStorage.setItem("authToken", token)
    localStorage.setItem("currentUser", JSON.stringify(user))
}
export function logout() {
    localStorage.removeItem("authToken");
    localStorage.removeItem("currentUser");
}
export async function checkEmailForResettingPassword(email){
    let response = await axios.post(`${apiEndPoint}/checkEmailForResettingPassword`,{email});
    return response.data
}
export async function updatePassword(email , password){
    let response = await axios ({
        method:'PUT',
        url:`${apiEndPoint}/password-reset`,
        data:{email,password}
    })
    return response.data
}
export function getCurrentUser() {
    let loggedInUser = localStorage.getItem('currentUser')
    loggedInUser = JSON.parse(loggedInUser)
    return loggedInUser
}

export default {
    login,
    logout,
    getCurrentUser,
    checkEmailForResettingPassword,
    updatePassword
}